export default {
  //全局使用
  global: {
    modalTitle: '提示',
    loginInvalid: '當前登錄失效，請重新登錄。',
  },
  errorTips: {
    paramsErr: '參數不符合校驗，請重新填寫提交。',
  },
  //首页相关
  //enter.js
  welcome: {
    title: 'MEET HIVE',
    enter: '點擊進入',
    brand: '蜂巢智慧',
    slogan: '讓城市生活更美好',
  },

  //welcomeHeader.js
  official: {
    website: 'MEETHIVE官網',
    product: '核心科技',
    about: '關於HI環衛',
  },

  //登录注册相关
  //welcome.js
  login: {
    detail: {
      account: '賬號',
      password: '密碼',
      inputPhoneNumber: '請輸入正確的手機號',
      wrongFormat: '賬號格式有誤',
      rules: '最少6位密码',
      inconsistent: '兩次密碼輸入不一致',
      phone: '手機號',
      inputPhone: '請輸入手機號',
      setAccount: '設置賬號',
      startRule: '請以字母開頭',
      repeatAccount: '用戶名重複',
      setPassword: '設置密碼',
      passwordRules: '密碼不少於六位',
      confirmPass: '確認密碼',
      pleaseConfirm: '請確認密碼',
    },
    title: 'HI峰巢',
    slogan: '讓城市生活更美好',
    checked: '記住密碼',
    logIn: '登錄',
    forget: '忘記密碼?',
    register: '註冊賬號',
    contract: {
      complete: '完成註冊',
      agree: '我已閱讀並同意',
      content: '《蜂巢服務條款》',
      serviceContent:
        '特別提示：<br/>\n' +
        '                                    以下條款是您與東莞蜂巢智慧智能科技有限公司（以下簡稱“蜂巢智慧”）於東莞市松山湖管委員會（以下簡稱“本協議替代地”）所採用的具有法律效力的協議。 您使用HI環衛軟件系統時權的權利以及相應的法律責任，HI環衛軟件系統指由東莞蜂巢智慧智能科技有限公司開發並作為本協議項下的軟件系統，包括且不包含計算機端網站，移動端 應用軟件及在第三方網絡平台上的公眾號和小程序。在本協議中，“您”指任何使用和訪問本服務的個人。<br/>\n' +
        '                                    請您仔細閱讀，充分理解本協議中各條款，包括免除或限制蜂巢智慧責任的免責條款以及對用戶的權利限制條款，點擊同意表明您已經閱讀並接受這些條款。如果您不接受本協議的 所有條款，請您停止註冊，登錄或使用本服務。您的註冊，登錄，使用等行為將視為您同意接受本協議的約束。<br/>\n' +
        '                                    蜂巢智慧可能會根據需要不時修訂或更新本協議及其相關補充和附件等文件，修訂或更新後的協議和文件一經公佈，立即取代原協議和文件，即自動生效。 或更新，請立即停止使用HI環衛服務或與蜂巢智慧聯繫；如您繼續使用HI環衛服務，即表示您已接受修訂或更新後的協議和文件。<br/>\n' +
        '\n' +
        '                                    1. 用戶註冊<br/>\n' +
        '                                    1.1 用戶權限向蜂巢智慧購買相關服務，獲得蜂巢智慧許可後，進行HI環衛的註冊工作，否則蜂巢智慧無法為客戶提供HI環衛的各類服務。<br/>\n' +
        '                                    1.2 用戶確認：HI環衛的註冊用戶包括政府機構，事業單位，企業以及政府以及政府機構，事業單位和企業的工作人員。用戶分為Ⅰ，Ⅱ，Ⅲ三級：Ⅰ級用戶為政府機構，事業單位，企業 ，由蜂巢智慧進行賬號分配；Ⅱ級用戶為政府機構，事業單位和企業的管理人員，由管理人員隸屬屬的單位進行賬號分配；Ⅲ級用戶為環衛工人，由環衛工人的上級進行賬號分配。<br/>\n' +
        '                                    1.3 註冊方式：已有用戶通過手機號進行綁定註冊。Ⅱ，Ⅲ級用戶在註冊前，可獲得獲得上級用戶發送的邀請鏈接，點擊邀請鏈接進行註冊。Ⅰ級用戶賬號由蜂巢智慧進行分配，分配後直接進行登錄。<br/>\n' +
        '                                    1.4 賬號管理：用戶註冊成功後，每個用戶獲得專屬賬號，禁止贈予，借用，租用，轉讓或售賣。用戶承擔其賬號與密碼的保管責任，除平台方（如微信）或蜂巢智慧的過錯外 ，用戶就其賬號及密碼項下一切活動負全部責任。<br/>\n' +
        '\n' +
        '                                    2. 服務範圍與使用規範<br/>\n' +
        '                                    2.1 Ⅰ級用戶可以在電腦端查看其分區區域內部所有果皮箱，垃圾桶的溢滿狀況，分配管理所屬工作人員的Ⅱ，Ⅲ級用戶賬號和果皮箱，垃圾桶，查看區域內工作人員數據與 果皮箱，垃圾桶數據；Ⅱ級用戶可以在電腦端查看其分區區域內所有果皮箱，垃圾桶的溢滿狀況，分配管理所屬工作人員的Ⅲ級用戶賬號和果皮箱，垃圾桶，查看分區 內工作人員數據與果皮箱，垃圾桶數據；Ⅰ，Ⅱ，Ⅲ三級用戶均可以在移動端及小程序查看其分區區域內所有果皮箱，垃圾桶的溢滿狀況與最佳路徑。<br/>\n' +
        '                                    2.2 用戶在使用HI環衛服務過程中，遵循遵循以下規則：<br/>\n' +
        '                                    1）遵守中華人民共和國法律法規和政府規定；<br/>\n' +
        '                                    2）不得利用HI環衛軟件系統進行任何可能對互聯網造成不利影響的行為；<br/>\n' +
        '                                    3）不得侵犯任何第三方的專利權，著作權，商標權，名譽權，專有權，個人信息或其他任何合法權益。<br/>\n' +
        '                                    2.3 蜂巢智慧有權在HI環衛系統上進行分類推廣以及廣告投放業務。<br/>\n' +
        '\n' +
        '                                    3. 傳感器的安裝與管理<br/>\n' +
        '                                    3.1 蜂巢智慧擁有品牌標記為“ HI-Tech”的傳感器的專利所有權，負責傳感器的安裝與維護。在傳感器安裝交付給客戶前，傳感器的歸屬於蜂巢智慧；交付後，傳感器的所有權歸屬於客戶單位 。<br/>\n' +
        '                                    3.2 未經蜂巢智慧同意，任何人不得破壞或移除所有權歸屬蜂巢智慧的傳感器，蜂巢智慧有權向其索賠；如破壞或可移除所有權歸屬他人的已經安裝的傳感器，蜂巢智慧亦有權產生所有者向其索賠。<br/>\n' +
        '                                    3.3 任何人不得在傳感器上允許廣告，吸附，不得對傳感器潑水，加熱。<br/>\n' +
        '\n' +
        '                                    4. 知識產權聲明<br/>\n' +
        '                                    4.1 HI環衛的一切著作權，商標權，專利權，商業秘密，數據等知識產權，以及相關的所有信息內容，包括但不限於：文字表述及其組合，圖標，圖飾，圖表，色彩，界面設計， 版面框架，有關數據，印刷材料，電子文檔等均受中華人民共和國著作權法，商標法，專利法，反不正當競爭法和相應的國際條約以及其他知識產權法律法規的保護。除涉及第三方授權 的軟件或技術外，蜂巢智慧享有HI環衛及其中所有內容的知識產權<br/>\n' +
        '                                    4.2 用戶不得對軟件或軟件運行過程中釋放到任何計算機終端內存中的數據及軟件運行過程中，客戶端與服務器端的交互數據進行下載，複製，更改，修改，掛接運行或創作任何衍生作品，形式包括但不限於插件，外掛或非經授權的第三方工具/服務。<br/>\n' +
        '\n' +
        '                                    5. 用戶數據及隱私政策<br/>\n' +
        '                                    5.1 用戶向蜂巢智慧提供的所有註冊資料應當是真實、完整、準確、合法、有效的。如果用戶提供的註冊資料有所變更，用戶可以及時更新，蜂巢智慧將依法對用戶信息進行檢查核實，用戶可以配合提供最及時，真實，完整的信息。<br/>\n' +
        '                                    5.2 蜂巢智慧依法保護用戶隱私，保證不對外公開或向第三方提供單個用戶的註冊資料及用戶在使用服務時存儲在HI環衛服務系統中受法律保護的隱私信息，以下情況除外：<br/>\n' +
        '                                    1）事先獲得用戶的明確同意；<br/>\n' +
        '                                    2）根據有關的法律法規要求；<br/>\n' +
        '                                    3）按照相關政府主管部門的要求；<br/>\n' +
        '                                    4）根據法院的生效判決、裁定或命令；<br/>\n' +
        '                                    5）為維護蜂巢智慧的合法權益或社會公共利益而在相關行政程序或司法程序中向政府主管部門或法院提供。<br/>\n' +
        '\n' +
        '                                    6. 免責聲明<br/>\n' +
        '                                    6.1 蜂巢智慧對服務不作任何類型的擔保，包括但不限於服務的及時性、安全性、準確性，對在任何情況下由可歸於用戶自身的原因導致的直接、間接、偶然、特殊及後續的損害及風險，蜂巢智慧不承擔責任。<br/>\n' +
        '                                    6.2 對於不可抗力、計算機病毒、黑客攻擊、系統不穩定、用戶所在位置、用戶關機以及其他任何網絡、技術、通信線路等原因造成的服務中斷或不能滿足用戶需求的風險，用戶理解並同意，蜂巢智慧對該等風險沒有過錯，蜂巢智慧不對此承擔責任。<br/>\n' +
        '                                    6.3 用戶充分理解並認可本協議各項約定，並同意蜂巢智慧免於承擔因用戶違反約定而產生的活與之有關的任何索賠、處罰、責任、費用或損失（包括但不限於第三方索賠），除非本協議另有約定或有證據證明蜂巢智慧對此具有重大過錯。<br/>\n' +
        '\n' +
        '                                    7. 違約責任<br/>\n' +
        '                                    7.1 如因蜂巢智慧違反有關法律法規或本協議項下的任何條款，而給用戶造成實際損失，蜂巢智慧同意承擔由此造成的違約責任。<br/>\n' +
        '                                    7.2 用戶同意保障和維護蜂巢智慧及其他用戶的合法權益，如因用戶違反有關法律法規或本協議項下的任何條款，而給蜂巢智慧或任何第三方造成損失，用戶同意承擔由此造成的違約責任，包括但不限於賠償蜂巢智慧並使蜂巢智慧免於因此遭受所有直接和間接損失（包括任何直接經濟損失、商譽損失及對外支付的賠償金、和解款、律師費、訴訟費等）。<br/>\n' +
        '\n' +
        '                                    8. 協議變更及終止<br/>\n' +
        '                                    8.1 鑑於互聯網服務市場及相關領域的快速發展及變化，用戶理解並同意，蜂巢智慧有權隨時修改本協議的任何條款，一旦本協議的內容髮生變動，蜂巢智慧會直接在HI環衛軟件系統上公佈修改後的協議內容（形式包括但不限於更新版本的協議、補充協議、協議新增附件等）。該公佈行為視為蜂巢智慧已經通知用戶修改內容，同時蜂巢智慧也可以通過其他適當方式向用戶提示修改內容。<br/>\n' +
        '                                    8.2 用戶不得單方終止本協議，如需終止本協議，應當聯繫蜂巢智慧進行友好的協商進行終止。<br/>\n' +
        '                                    8.3 蜂巢智慧在出現以下任何情況是，蜂巢智慧有權單方終止本協議：<br/>\n' +
        '                                    1）用戶嚴重違反本協議約定，或多次違反本協議約定；<br/>\n' +
        '                                    2）用戶行為存在異常，我們合理懷疑用戶可能存在違法或違反本協議約定的行為，如果不終止本協議可能對蜂巢智慧、其他用戶、公共秩序或公共利益造成不利影響；<br/>\n' +
        '                                    3）用戶存在盜用他人賬號、發布違禁信息、騙取他人財物、採取不正當手段牟利等行為；<br/>\n' +
        '                                    4）其他應當終止本協議的情況。<br/>\n' +
        '                                    8.4 本協議終止後，除法律另有明確規定外，蜂巢智慧無義務向用戶或任何指定的第三方披露該用戶賬號中的任何信息。本協議終止後，蜂巢智慧仍享有以下權利：<br/>\n' +
        '                                    1）繼續保存留存於HI環衛軟件系統中的各類信息；<br/>\n' +
        '                                    2）對於用戶過往的違約行為，我們仍可依據本協議追究其違約責任。<br/>\n' +
        '\n' +
        '                                    9. 適用法律與爭議解決<br/>\n' +
        '                                    9.1 本協議的訂立、履行和解釋及與之相關的爭議的解決均應適用中華人民共和國法律。<br/>\n' +
        '                                    9.2 如您與蜂巢智慧就本協議及其所有補充和附件的簽署、內容、解釋或其執行發生任何爭議，雙方應盡量友好協商解決；協商不成時，對於因本協議及其所有補充和附件而產生的或與之有關的一切爭議，您同意將其提交本協議簽訂地有管轄權的人民法院管轄。<br/>\n' +
        '\n' +
        '                                    10. 其他規定<br/>\n' +
        '                                    10.1 如本協議中的任何條款無論因何種原因完全或部分無效或不具有執行力，不影響本協議其他條款的效力。在此情形下，各方應當在合法範圍內協商確定新的條款，以保證最大限度地實現原有條款的意圖。<br/>\n' +
        '                                    10.2 本協議中的標題為方便理解而設，在解釋本協議時不受該標題的限制。<br/>\n' +
        '                                    10.3 任何一方當事人放棄或延遲行使其在本協議項下的全部或部分權利的，不應視為其放棄本協議項下的任何其他權利或與此類似的一切權利。<br/>',
    },
    registerSure: '確認',
    hadOrReturn: '已有賬號?返回登錄',
  },

  //用户相关
  //userListItem.jsx
  userListInfo: {
    distribute: '分配箱子',
    edit: '編輯',
    del: '刪除',
    info: '基本信息',
    safe: '安全',
    weChat: '微信',
    account: '賬號',
    unKnow: '未知',
    shield: '屏蔽',
    shieldInfo:
      '屏蔽後該微信號將無法正常登陸HI環衛，但通過解除屏蔽可正常登陸，確認執行此操作嗎？',
    unblock: '解除屏蔽',
    unblockInfo: '解除屏蔽後該微信號可正常登陸HI環衛，確認執行此操作嗎？',
    MessageReminder: '消息提醒',
    open: '開',
    close: '關',
    phone: '手機',
    phoneNum: '手機號',
    unset: '未設置',
    email: '郵箱',
    emailNum: '郵箱號',
    okText: '確定',
    cancelTxt: '取消',
    workbenchReminder: '工作台溢滿提醒',
    workbenchReminderTips:
      '位於工作台右側的箱體詳情列表裡，長期未清理的箱體可設置強提醒。',
    highlight: '置頂顯示',
    musicTips: '聲音',
    untie: '解綁',
    untieTips: '解綁後該微信號將無法登陸到HI環衛，確認執行此操作嗎？',
    untiePhone: '解綁後該手機號將無法登陸到HI環衛，確認執行此操作嗎？',
    untieEmail: '解綁後該郵箱號將無法登陸到HI環衛，確認執行此操作嗎？',
  },
  //userList.jsx
  userList: {
    icon: '+ ',
    create: '創建',
    total: '共',
    area: '個區域',
  },

  //创建团队相关
  createTeam: {
    teamManage: '團隊管理',
    teamTip: '注意',
    tipDetail: '您目前還沒有團隊，快來創建團隊吧~',
    createATeam: '創建',
    group: {
      name: '團隊名稱',
      inputName: '請輸入團隊名稱!',
      rules: '(中文、字母、數字、下劃線)',
      digital: '6位以上',
      demands: '可填寫公司名或其他具代表性名稱',
    },
    email: {
      mailBox: '郵箱',
      inputAddress: '請輸入郵箱!',
      wrongFormat: '格式錯誤',
      demands: '請輸入您的郵箱號',
    },
    groupAdd: {
      address: '團隊地址',
      inputAddress: '請輸入團隊地址!',
      rules: '(中文、字母、數字、下劃線)',
      digital: '3位以上',
      demands: '您的團隊地址(例：山東省菏澤市)',
      create: '創建',
    },
    info: {
      tip: '注意',
      congratulate:
        '恭喜您創建成功！之後可在 我的賬戶\n' +
        '                  面板對剛填寫的信息進行再次修改。',
      got: '好的，我知道了',
      create: '創建',
    },
    createMyAccount: '創建我的賬戶',
    completeness: '完整度',
  },

  //员工首页信息相关
  staffHomeInfo: {
    working: '工作中',
    prepareToWork: '準備工作中',
    prepareToClean: '準備清運中',
    name: '姓名',
    phone: '電話',
    region: '區域',
    member: '環衛員工',
    workplace: '工作區域',
    clearSpeed: '清運速度',
    unit: '小時/桶',
    currState: '當前狀態',
    workplaceState: '工作區域狀態',
    halfMonthNotClear: '半月未清',
    overflow: '溢滿',
    halfFull: '半滿',
    empty: '量少',
    single: '個',
    dailyClear: '今日已清運',
    dailyClear2: '今日已清運',
    hour: '小時',
    kilos: '千克',
    clearTotalTime: '清運時間統計',
    forecastInfo:
      '此趨勢圖表示近七天內此環衛工人每天清運所花費的實際時間。所用時間較多，環衛工人在戶外工作的勞動風險高；所用時間較少，環衛工人的勞動價值體現少；管理者可以將環衛工人實際清運時間控制在一定範圍內，如果需要本系統在此方面也可以給出一些建議。',
    forecastInfoDes: {
      main: '近七天內此環衛工人出行清運的時刻主要分佈在',
      time: '點和',
      timeClock: '點',
      average: '；平均每天花費',
      hour: '小時',
      action: '進行清運。',
    },
    forecastInfoDes2: {
      clearTotal: '清運總量統計',
      forecastInfo:
        '此趨勢圖表示近七天內此環衛工人每天清運垃圾的總量。每天清運垃圾的總量主要取決於此區域每天垃圾的產生總量；管理者可以盡可能使每一個環衛工人工作區域的清運量相等，如果需要本系統在此方面也可以給出一些建議。',
      unit: '(kg)',
      forecast: {
        main: '近七天內此環衛工人工作區域的垃圾主要分佈在',
        time: '點和',
        timeClock: '點。',
        timeDetail: '這兩個時刻產生；',
        average: '平均每天環衛工人要清運',
        unit: '千克',
        rush: '垃圾。',
      },
    },
    return: '返回到地圖',
    cleanTime: '清運時長',
    cleanAmount: '清運總量',
  },

  //navigator.js
  // 管理界面
  manage: {
    home: '首頁',
    areaManage: '區域管理',
    areaDivision: '區域劃分',
    dataCount: '數據統計',
    staffDataCount: '區域動態',
    dataAnalysis: '大數據分析平台',
    dataDetail: '數據明細',
    dynamicData: '動態數據圖',
    equipmentManage: '設備管理',
    equipmentWithError: '故障設備',
    equipmentSpec: '規格管理',
    equipmentPower: '電量管理',
    accountManage: '賬號管理',
    myAccount: '我的賬戶',
    helpCenter: '幫助中心',
    commonQuestions: '常見問題',
    support: '支持',
    exitAccount: '退出賬戶',
    shrinkTab: '縮小面板',
    serviceAccount: '服務賬戶',
  },

  manageTop: {
    exit: '退出',
  },

  //溢满时间
  time: {
    day: '日',
    week: '周',
    month: '月',
  },

  //tips相关
  tipsInfo: {
    littleTip: '提示',
    chooseContent: '車庫倉庫確定后，點擊左側“應用”完成設置！',
    forSure: '確定',
    cancel: '取消',
  },

  //overview.js
  toolbar: {
    leftFloatWindow: {
      header: '負責人',
      existQuantity: '已有量',
      allNoticed: '已通知',
    },
    floatWindowDetail: {
      acknowledged: '我知道了',
      trend: '趨勢',
      trendDes:
        '此趨勢圖表示某時間段內該垃圾桶桶內的已有量，通過分析此圖可以掌握該垃圾桶清運時間的規律，以此進行清運規劃，提高效率，節約人力。',
      trendGraph: {
        day: '日',
        week: '周',
        month: '月',
        noData: '本月無數據',
        dataDes: '已有量',
      },
    },
    pieChartDes: {
      remainCapacity: '剩餘容量',
      occupiedCapacity: '已佔容量',
    },
    lineChart: {
      title: '已有量',
    },
    tipInfo: {
      tryScroll: '鼠標滾動試試，時間線條會',
      moreDetailed: '變的更詳細哦~',
      acknowledge: '我知道了',
    },
    trendDes: {
      trend: '趨勢',
      trendInfo:
        '此趨勢圖表示某時間段內該垃圾桶桶內的已有量，通過分析此圖可以掌握該垃圾桶清運時間的規律，以此進行清運規劃，提高效率，節約人力。',
      trendIcon: 'i',
      day: '日',
      week: '周',
      month: '月',
      detail: '詳情',
      existingQuantity: '已有量',
    },
    home: '首頁',
    staffManage: '人員管理',
    createATeam: '創建團隊',
    controlArea: '區域管理',
    data: '數據統計',
    deviceManagement: '設備管理',
    accountManage: '賬戶管理',
    helpCenter: '幫助中心',
    myAccount: '我的賬戶',
    logout: '退出登錄',
    unfoldTab: ' 展開面板',
    rightFloatWindow: {
      switch: '點擊可以收起/展開側面面板',
      haveKnown: '我知道了',
      allAcknowledge: '點擊“全部已通知”可處理全部長期未處理箱子',
      placeholder: '請輸入桶的ID或者名稱',
      allList: '全部',
      showAll: '顯示全部',
      showRed: '顯示紅色',
      showOrange: '顯示橘色',
      showGreen: '顯示綠色',
      existQuantity: '已有量',
      showID: '顯示ID',
      showName:'顯示名稱',
      allNoticed: '全部已通知',
      todayNeedCollect: '今日需收',
      canQuantity: '個',
      hideEmpty: '隱藏空桶',
      showEmpty: '顯示空桶',
    },
    edit: '點擊編輯',
    number: 'No.',
    exit: '登出',
    none: '無',
  },

  //management.js
  areaManagement: {
    title: '區域劃分',
    districtAdministrator: '大區',
    staff: '下屬工作區',
    typeList: '大區列表',
    subWorkArea: '下屬工作區',
    tip: '注意',
    confirmDelete: '請確定是否執行”刪除“操作',
    deleteForSure: '確認刪除',
    hasSubordinateUser:
      '當前大區存在下屬工作區，請刪除下屬工作區後再刪除當前大區。',
    deleteErr: '刪除失敗',
    cancel: '取消',
    searchYouWant: '在這輸入想找的對象...',
  },

  //login.jsx
  logIn: {
    accountNotExist: '用戶名不存在',
    passwordError: '密碼錯誤',
    unknownError: '未知錯誤',
    inputNumber: '請輸入賬號',
    account: '賬戶號',
    inputPassword: '請輸入密碼',
    passwordDemand: '請輸入6位數或6位數以上的密碼',
    password: '密碼',
    rememberPassword: '記住密碼',
    forgetPassword: '忘記密碼？',
    loggedIn: '登錄',
    getVerified: '獲取驗證碼',
    notRepeatClick: '請勿重複點擊',
    phoneNotBind: '手機號未綁定',
    wrongVerifiedCode: '驗證碼錯誤',
    inputPhoneNumber: '請輸入手機號',
    validPhoneNumber: '請輸入有效的手機號',
    phone: '手機號',
    inputVerifiedCode: '請輸入驗證碼',
    inputCorrectCode: '請輸入正確的驗證碼',
    verificationCode: '驗證碼',
    getVerifiedCode: '驗證碼已發送到你的手機，15分鐘內有效',
    notReceivedCode: '沒有收到驗證碼',
    notReceivedReason:
      '網絡通訊異常可能會造成短信丟失，請重新獲取或稍後重試。如果手機號已丟失或停用，請選擇其他方式登錄。',
    emailNotBind: '郵箱未綁定',
    inputEmailAccount: '請輸入郵箱號',
    inputValidEmail: '請輸入有效的郵箱號',
    getEmailVerifiedCode: '驗證碼已發送到你的郵箱，15分鐘內有效',
    emailAccount: '郵箱號',
    notReceivedReason2:
      '網絡通訊異常可能會造成郵件丟失，請重新獲取或稍後重試。',
    loggedInHI: '登錄HI環衛',
    noAccount: '沒有賬號?',
    registerImmediately: '立即註冊',
    otherWayLog: '其他方式登錄',
    verifiedByPhone: '手機號登錄',
    verifiedByEmail: '郵箱登錄',
    verifiedByPassword: '賬號密碼登錄',
  },

  //register.js
  register: {
    inconsistentPasswords: '兩次輸入密碼不相同',
    accountDemand: {
      inputAccount: '賬號重複',
      atLeastLength: '賬號最少6位',
      formatSetting: '英文字母開頭,6~18位(字母、數字、下劃線)',
      accountSetting: '請設置賬號',
    },
    passwordDemand: {
      inputPassword: '請輸入密碼',
      passwordLength: '請設置為6位數或6位數以上的密碼',
      passwordSetting: '設置密碼',
      confirmPassword: '請確認您的密碼',
      inputAgain: '再次輸入密碼',
    },
    registerAcc: '註冊',
    agree: '我已閱讀並同意《蜂巢服務條款》',
    reminding: '蜂巢智慧提醒您：',
    success: '註冊成功!',
    terms: '蜂巢服務條款',
    contract: {
      serviceContent:
        '特別提示：<br/>\n' +
        '                                    以下條款是您與東莞蜂巢智慧智能科技有限公司（以下簡稱“蜂巢智慧”）於東莞市松山湖管委員會（以下簡稱“本協議替代地”）所採用的具有法律效力的協議。 您使用HI環衛軟件系統時權的權利以及相應的法律責任，HI環衛軟件系統指由東莞蜂巢智慧智能科技有限公司開發並作為本協議項下的軟件系統，包括且不包含計算機端網站，移動端 應用軟件及在第三方網絡平台上的公眾號和小程序。在本協議中，“您”指任何使用和訪問本服務的個人。<br/>\n' +
        '                                    請您仔細閱讀，充分理解本協議中各條款，包括免除或限制蜂巢智慧責任的免責條款以及對用戶的權利限制條款，點擊同意表明您已經閱讀並接受這些條款。如果您不接受本協議的 所有條款，請您停止註冊，登錄或使用本服務。您的註冊，登錄，使用等行為將視為您同意接受本協議的約束。<br/>\n' +
        '                                    蜂巢智慧可能會根據需要不時修訂或更新本協議及其相關補充和附件等文件，修訂或更新後的協議和文件一經公佈，立即取代原協議和文件，即自動生效。 或更新，請立即停止使用HI環衛服務或與蜂巢智慧聯繫；如您繼續使用HI環衛服務，即表示您已接受修訂或更新後的協議和文件。<br/>\n' +
        '\n' +
        '                                    1. 用戶註冊<br/>\n' +
        '                                    1.1 用戶權限向蜂巢智慧購買相關服務，獲得蜂巢智慧許可後，進行HI環衛的註冊工作，否則蜂巢智慧無法為客戶提供HI環衛的各類服務。<br/>\n' +
        '                                    1.2 用戶確認：HI環衛的註冊用戶包括政府機構，事業單位，企業以及政府以及政府機構，事業單位和企業的工作人員。用戶分為Ⅰ，Ⅱ，Ⅲ三級：Ⅰ級用戶為政府機構，事業單位，企業 ，由蜂巢智慧進行賬號分配；Ⅱ級用戶為政府機構，事業單位和企業的管理人員，由管理人員隸屬屬的單位進行賬號分配；Ⅲ級用戶為環衛工人，由環衛工人的上級進行賬號分配。<br/>\n' +
        '                                    1.3 註冊方式：已有用戶通過手機號進行綁定註冊。Ⅱ，Ⅲ級用戶在註冊前，可獲得獲得上級用戶發送的邀請鏈接，點擊邀請鏈接進行註冊。Ⅰ級用戶賬號由蜂巢智慧進行分配，分配後直接進行登錄。<br/>\n' +
        '                                    1.4 賬號管理：用戶註冊成功後，每個用戶獲得專屬賬號，禁止贈予，借用，租用，轉讓或售賣。用戶承擔其賬號與密碼的保管責任，除平台方（如微信）或蜂巢智慧的過錯外 ，用戶就其賬號及密碼項下一切活動負全部責任。<br/>\n' +
        '\n' +
        '                                    2. 服務範圍與使用規範<br/>\n' +
        '                                    2.1 Ⅰ級用戶可以在電腦端查看其分區區域內部所有果皮箱，垃圾桶的溢滿狀況，分配管理所屬工作人員的Ⅱ，Ⅲ級用戶賬號和果皮箱，垃圾桶，查看區域內工作人員數據與 果皮箱，垃圾桶數據；Ⅱ級用戶可以在電腦端查看其分區區域內所有果皮箱，垃圾桶的溢滿狀況，分配管理所屬工作人員的Ⅲ級用戶賬號和果皮箱，垃圾桶，查看分區 內工作人員數據與果皮箱，垃圾桶數據；Ⅰ，Ⅱ，Ⅲ三級用戶均可以在移動端及小程序查看其分區區域內所有果皮箱，垃圾桶的溢滿狀況與最佳路徑。<br/>\n' +
        '                                    2.2 用戶在使用HI環衛服務過程中，遵循遵循以下規則：<br/>\n' +
        '                                    1）遵守中華人民共和國法律法規和政府規定；<br/>\n' +
        '                                    2）不得利用HI環衛軟件系統進行任何可能對互聯網造成不利影響的行為；<br/>\n' +
        '                                    3）不得侵犯任何第三方的專利權，著作權，商標權，名譽權，專有權，個人信息或其他任何合法權益。<br/>\n' +
        '                                    2.3 蜂巢智慧有權在HI環衛系統上進行分類推廣以及廣告投放業務。<br/>\n' +
        '\n' +
        '                                    3. 傳感器的安裝與管理<br/>\n' +
        '                                    3.1 蜂巢智慧擁有品牌標記為“ HI-Tech”的傳感器的專利所有權，負責傳感器的安裝與維護。在傳感器安裝交付給客戶前，傳感器的歸屬於蜂巢智慧；交付後，傳感器的所有權歸屬於客戶單位 。<br/>\n' +
        '                                    3.2 未經蜂巢智慧同意，任何人不得破壞或移除所有權歸屬蜂巢智慧的傳感器，蜂巢智慧有權向其索賠；如破壞或可移除所有權歸屬他人的已經安裝的傳感器，蜂巢智慧亦有權產生所有者向其索賠。<br/>\n' +
        '                                    3.3 任何人不得在傳感器上允許廣告，吸附，不得對傳感器潑水，加熱。<br/>\n' +
        '\n' +
        '                                    4. 知識產權聲明<br/>\n' +
        '                                    4.1 HI環衛的一切著作權，商標權，專利權，商業秘密，數據等知識產權，以及相關的所有信息內容，包括但不限於：文字表述及其組合，圖標，圖飾，圖表，色彩，界面設計， 版面框架，有關數據，印刷材料，電子文檔等均受中華人民共和國著作權法，商標法，專利法，反不正當競爭法和相應的國際條約以及其他知識產權法律法規的保護。除涉及第三方授權 的軟件或技術外，蜂巢智慧享有HI環衛及其中所有內容的知識產權<br/>\n' +
        '                                    4.2 用戶不得對軟件或軟件運行過程中釋放到任何計算機終端內存中的數據及軟件運行過程中，客戶端與服務器端的交互數據進行下載，複製，更改，修改，掛接運行或創作任何衍生作品，形式包括但不限於插件，外掛或非經授權的第三方工具/服務。<br/>\n' +
        '\n' +
        '                                    5. 用戶數據及隱私政策<br/>\n' +
        '                                    5.1 用戶向蜂巢智慧提供的所有註冊資料應當是真實、完整、準確、合法、有效的。如果用戶提供的註冊資料有所變更，用戶可以及時更新，蜂巢智慧將依法對用戶信息進行檢查核實，用戶可以配合提供最及時，真實，完整的信息。<br/>\n' +
        '                                    5.2 蜂巢智慧依法保護用戶隱私，保證不對外公開或向第三方提供單個用戶的註冊資料及用戶在使用服務時存儲在HI環衛服務系統中受法律保護的隱私信息，以下情況除外：<br/>\n' +
        '                                    1）事先獲得用戶的明確同意；<br/>\n' +
        '                                    2）根據有關的法律法規要求；<br/>\n' +
        '                                    3）按照相關政府主管部門的要求；<br/>\n' +
        '                                    4）根據法院的生效判決、裁定或命令；<br/>\n' +
        '                                    5）為維護蜂巢智慧的合法權益或社會公共利益而在相關行政程序或司法程序中向政府主管部門或法院提供。<br/>\n' +
        '\n' +
        '                                    6. 免責聲明<br/>\n' +
        '                                    6.1 蜂巢智慧對服務不作任何類型的擔保，包括但不限於服務的及時性、安全性、準確性，對在任何情況下由可歸於用戶自身的原因導致的直接、間接、偶然、特殊及後續的損害及風險，蜂巢智慧不承擔責任。<br/>\n' +
        '                                    6.2 對於不可抗力、計算機病毒、黑客攻擊、系統不穩定、用戶所在位置、用戶關機以及其他任何網絡、技術、通信線路等原因造成的服務中斷或不能滿足用戶需求的風險，用戶理解並同意，蜂巢智慧對該等風險沒有過錯，蜂巢智慧不對此承擔責任。<br/>\n' +
        '                                    6.3 用戶充分理解並認可本協議各項約定，並同意蜂巢智慧免於承擔因用戶違反約定而產生的活與之有關的任何索賠、處罰、責任、費用或損失（包括但不限於第三方索賠），除非本協議另有約定或有證據證明蜂巢智慧對此具有重大過錯。<br/>\n' +
        '\n' +
        '                                    7. 違約責任<br/>\n' +
        '                                    7.1 如因蜂巢智慧違反有關法律法規或本協議項下的任何條款，而給用戶造成實際損失，蜂巢智慧同意承擔由此造成的違約責任。<br/>\n' +
        '                                    7.2 用戶同意保障和維護蜂巢智慧及其他用戶的合法權益，如因用戶違反有關法律法規或本協議項下的任何條款，而給蜂巢智慧或任何第三方造成損失，用戶同意承擔由此造成的違約責任，包括但不限於賠償蜂巢智慧並使蜂巢智慧免於因此遭受所有直接和間接損失（包括任何直接經濟損失、商譽損失及對外支付的賠償金、和解款、律師費、訴訟費等）。<br/>\n' +
        '\n' +
        '                                    8. 協議變更及終止<br/>\n' +
        '                                    8.1 鑑於互聯網服務市場及相關領域的快速發展及變化，用戶理解並同意，蜂巢智慧有權隨時修改本協議的任何條款，一旦本協議的內容髮生變動，蜂巢智慧會直接在HI環衛軟件系統上公佈修改後的協議內容（形式包括但不限於更新版本的協議、補充協議、協議新增附件等）。該公佈行為視為蜂巢智慧已經通知用戶修改內容，同時蜂巢智慧也可以通過其他適當方式向用戶提示修改內容。<br/>\n' +
        '                                    8.2 用戶不得單方終止本協議，如需終止本協議，應當聯繫蜂巢智慧進行友好的協商進行終止。<br/>\n' +
        '                                    8.3 蜂巢智慧在出現以下任何情況是，蜂巢智慧有權單方終止本協議：<br/>\n' +
        '                                    1）用戶嚴重違反本協議約定，或多次違反本協議約定；<br/>\n' +
        '                                    2）用戶行為存在異常，我們合理懷疑用戶可能存在違法或違反本協議約定的行為，如果不終止本協議可能對蜂巢智慧、其他用戶、公共秩序或公共利益造成不利影響；<br/>\n' +
        '                                    3）用戶存在盜用他人賬號、發布違禁信息、騙取他人財物、採取不正當手段牟利等行為；<br/>\n' +
        '                                    4）其他應當終止本協議的情況。<br/>\n' +
        '                                    8.4 本協議終止後，除法律另有明確規定外，蜂巢智慧無義務向用戶或任何指定的第三方披露該用戶賬號中的任何信息。本協議終止後，蜂巢智慧仍享有以下權利：<br/>\n' +
        '                                    1）繼續保存留存於HI環衛軟件系統中的各類信息；<br/>\n' +
        '                                    2）對於用戶過往的違約行為，我們仍可依據本協議追究其違約責任。<br/>\n' +
        '\n' +
        '                                    9. 適用法律與爭議解決<br/>\n' +
        '                                    9.1 本協議的訂立、履行和解釋及與之相關的爭議的解決均應適用中華人民共和國法律。<br/>\n' +
        '                                    9.2 如您與蜂巢智慧就本協議及其所有補充和附件的簽署、內容、解釋或其執行發生任何爭議，雙方應盡量友好協商解決；協商不成時，對於因本協議及其所有補充和附件而產生的或與之有關的一切爭議，您同意將其提交本協議簽訂地有管轄權的人民法院管轄。<br/>\n' +
        '\n' +
        '                                    10. 其他規定<br/>\n' +
        '                                    10.1 如本協議中的任何條款無論因何種原因完全或部分無效或不具有執行力，不影響本協議其他條款的效力。在此情形下，各方應當在合法範圍內協商確定新的條款，以保證最大限度地實現原有條款的意圖。<br/>\n' +
        '                                    10.2 本協議中的標題為方便理解而設，在解釋本協議時不受該標題的限制。<br/>\n' +
        '                                    10.3 任何一方當事人放棄或延遲行使其在本協議項下的全部或部分權利的，不應視為其放棄本協議項下的任何其他權利或與此類似的一切權利。<br/>',
    },
    aAccount: '註冊賬號',
    haveAcc: '已有賬號？',
    goLogin: '去登錄',
  },
  //welcomeStore.js
  verifiedInfo: {
    getCode: '獲取驗證碼',
  },

  //home.js
  //退出弹窗
  exitModal: {
    tip: '注意',
    confirm: '請確定是否退出當前賬號',
    sure: '確定',
    cancel: '取消',
  },

  //distributeCans.js
  //分配箱子
  allocateCans: {
    manager: '負責人',
    area: '負責區域',
    canCount: '負責箱體數',
    unset: '未設置',
    edit: '點擊編輯',
    inputWorkspace: '請輸入工作區域',
    unit: '個',
    willAllocate: '待分配箱體',
    inChargingCans: '負責中箱體',
    search: '搜索',
    searchByID: '輸入名稱或ID查找',
    total: '共',
    equipment: '個設備',
    distribute: '分配',
    remove: '移出',
    got: '我知道了',
    gotDetail: '勾選垃圾桶後，即可開始分配垃圾桶。',
    toolbar: {
      home: '首頁',
      staffManagement: '人員管理',
      createATeam: '創建團隊',
      data: '數據',
      equipmentManage: '設備管理',
      accountManage: '賬戶管理',
      help: '幫助中心',
      myAcc: '我的賬戶',
      unfoldTab: '展開面板',
    },
    all:'全选',
  },
  //thermodynamic.js
  thermodynamic: {
    tips: '无數據！',
  },
  //DataDetail.js
  dataInfo: {
    unit: 'kg',
    detail: '數據明細',
    selectArea: '全部',
    import: '導出',
    time: '時間',
    area: '區域',
    total: '共',
    count: '個區域',
    prevPage: '上一頁',
    nextPage: '下一頁',
    page: '頁',
    daily: '日報表',
    month: '月報表',
    exportData: '導出數據記錄',
    rangeOfArea: '區域範圍',
    chooseArea: '選擇區域範圍',
    rangeOfTime: '時間範圍',
    sure: '確定',
    cancel: '取消',
    remind: '蜂巢智慧提醒您！',
    load: '下載',
    exportTipsTxt: '文件創建成功，您可以點擊下載按鈕來下載文件。',
    TipsPermissionErr: '權限錯誤',
    TipsBuildFail: '文件創建失敗',
  },

  //Analysis.js
  dataAnalysis: {
    stability: '平穩',
    weightUnit: 't',
    collect: '收集量',
    deviceUnit: '個',
    isRunning: '設備正在運行',
    save: {
      water: '節約水',
      electricity: '節約電',
    },
    reduce: {
      burnAmount: '減少垃圾焚燒量',
      buryAmount: '減少垃圾填埋量',
    },
    controlArea: '管理區域',
    exportReduceData: '導出減量數據',
    operatePerson: '管理人員',
    operateArea: '區域管理',
    chooseArea: '全部',
    none: '無',
    cleaning: '清運',
    count: '次',
    prevPage: '上一頁',
    nextPage: '下一頁',
    accumulate: '累計回收廢品',
    weightUnit2: 'kt',
    weightUnit3: 'mw·h',
    estimateSaving: '每年預計節約',
    estimateReducing: '每年預計減少',
    lastSevenDaysResource: '近7天節約資源量',
    lastSevenDaysTrash: '近7天減少垃圾處理量',
    personOperate: '人員管理',
    cleanTeam: '清運員工團隊',
    cleanState: '人正在清運中...',
    analysisPlatform: '大數據分析平台',
    totalOperateState: '整體運行狀態',
    middle: '良好',
    score: '87分',
    toolbar: {
      home: '首頁',
      statistic: '數據統計',
      area: '區域管理',
      equipment: '設備管理',
      account: '我的賬戶',
      exit: '退出賬戶',
      fullScreen: '全屏顯示',
      exitFullScreen: '退出全屏',
    },
  },

  //Equipment.js
  deviceError: {
    number: 'No.',
    haveResolved: '已解決',
    haveNotResolved: '未解決',
    reason: {
      contactFailure: '無法交流',
      communicateError: '通信困難',
      measureDifficulty: '測距困難',
      measureIncorrect: '測不准',
      restart: '設備重新啟動',
      deviceMiss: '丟失',
      other: '其他原因',
    },
    noErrorDevice: '此用戶無故障設備',
    tip: '注意',
    sure: '確定',
    cancel: '取消',
    deleteAllRecord: '請確定是否將此故障設備的所有錯誤記錄刪除',
    confirmDelete: '您確認執行“解決”操作嗎？',
    deviceProblem: {
      deviceFaulty: '故障設備',
      totalDeviceFaulty: '故障設備總計',
      cannotCommunicate: '無法交流設備',
      hardToCommunicate: '通信困難',
      hardToMeasure: '測距困難',
      incorrectMeasure: '測不准',
      otherErrorDevice: '其他故障設備',
      haveResolvedDevice: '已為您解決設備',
      deviceUnit: '個',
      name: '設備名稱',
      number: '設備編號',
      type: '錯誤類型',
      status: '狀態',
      total: '共',
      records: '條記錄',
    },
    page: {
      prevPage: '上一頁',
      nextPage: '下一頁',
      total: '共',
      pages: '頁',
      number: 'NO.',
    },
    records: {
      deleteAll: '刪除全部記錄',
      total: '共',
      recording: '條記錄',
      prev: '上一頁',
      next: '下一頁',
    },
    allPlace: '全部',
    beilin: '碑林',
    expireDate: '到期時間',
    allChecked: '全選',
    detail: {
      name: '設備名稱',
      number: '設備編號',
      area: '所屬轄區',
      time: '到期時間',
      status: '狀態',
    },
    item: {
      area:
        '長春騰花園長春騰花園長春騰花園長春騰花園長春騰花園長春騰花園長春騰花園長春騰花園',
      deviceNumber: 'NO.324434344444',
      region: '陝西省西安市',
      date: '2019/06/01',
      expired: '已到期',
      totalDevice: '共 9 個設備',
      prevPage: '上一頁',
      pageNumber: '1',
      nextPage: '下一頁',
      charge: '去續費',
    },
  },

  //account.js
  myAccount: {
    account: '我的賬戶',
    accountPartOne: {
      detail: '賬戶信息',
      superAdmin: '超級管理員',
      commonAdmin: '管理員',
      accNumber: '賬戶',
      tel: '聯繫電話',
      email: '郵箱',
      address: '聯繫地址',
      unset: '未設置',
      detailInfo: {
        cleanUnit: '189個',
        cleanerNumber: '清運人員',
        carUnit: '189個',
        carNumber: '清運車輛',
      },
      edit: '編輯',
      view: '查看',
    },
    accountPartTwo: {
      myDevice: '我的設備',
      deviceNumber: '<span>--</span>個',
      // deviceInfo: '在運行--個，待續費--個，待分配--個',
      deviceInfo: '在運行--個，待分配--個',
      aboutDevice: '<其中在運行1036個，待續費3個，待分配15個>',
      orderNewDevice: '訂購新設備',
      rechargeNewDevice: '充值現有設備',
      orderHistory: '歷史訂單',
      renewal: '設備續費',
    },
    accountPartThree: {
      myBalance: '我的餘額',
      balanceDetail: '￥',
      charge: '充值',
      chargeHistory: '充值歷史',
      todo: '待辦事項',
      develop: '開發中',
      you: '您有',
      renew: '個設備急需續費。',
      toRenew: '去續費 >>',
      Allocate: '個設備處於未分配狀態，快去分配吧。',
      toAllocate: '去管理人員分配 >>',
      improved: '您的賬戶資料有待完整哦~',
      toImproved: '去編輯 >>',
      know: '我知道了',
      empty: '暫無待辦事項~',
    },
    accountPartFour: {
      securitySet: '安全設置',
      login: '登錄密碼',
      passwordSuggest: '安全性高的密碼可以使賬號更安全，建議您更換密碼。',
      haveSet: '已設置',
      modify: '修改',
      bindPhone: '手機綁定',
      unset: '未設置',
      unsetDetail: '你還沒有綁定手機',
      haveBind: '您已經綁定了手機',
      useYourPhone: '（您的手機可以直接用於登錄、找回密碼等)',
      unbind: '解綁成功',
      bind: '綁定',
      toUnbind: '解綁',
      logout: '退出賬號',
      // logoutInfo:
      //   '如果您需要切換賬號或其他退出需求，可以將其退出。退出後不影響再次進入。'
    },
    bookNewDevice: {
      orderNewDevice: '訂購新設備',
      commonSensor: '通用型HIOS傳感器',
      newGeneration: '新一代',
      model: '型號',
      storage: '存儲',
      scene: '場景',
      installationType: '安裝類型',
      format: '規格',
      quantity: '數量(個)',
      power: '供電方式',
      transform: '通信模式',
      distance: '測距距離',
      integrated: '集成款',
      help: '幫助',
      helpText:
        '多探頭集成款包含多個探頭，可用於集成到包含多個內容的收集容器中',
      position: '定位',
      duration: '時長',
      order: '結算',
      cancel: '取消',
      free: '省',
      yuan: '元',
      multiple: '探頭集成款',
      month: '個月',
    },
    aboutBind: {
      successBind: '綁定成功',
      wrongPhoneNumberFormat: '手機號格式不正確',
      fillNumber: '請填寫完整的手機號',
      wrongFormatNumber: '手機號格式不正確',
      numberHaveBound: '手機號已經綁定',
      wrongVerifiedCode: '驗證碼錯誤',
      sendCode: '發送驗證碼',
      modifyPhone: '修改綁定手機',
      rebind: '新綁定手機',
      verifiedCode: '手機驗證碼',
      inputPhoneNumber: '請輸需要綁定的手機號',
      inputCode: '請填寫6位數字驗證碼',
      sure: '確定',
      cancel: '取消',
      inputRightPassword: '請輸入正確的密碼',
      passRules: '6~18位(字母、數字、常用字符、字母區分大小寫)',
      inconsistentPasswords: '兩次輸入密碼不相同',
      originalFalse: '原密碼錯誤',
      tryTwice: '請重新登錄',
      demands: '密碼應該在6~20位之間',
      modify: '修改登錄密碼',
      currPassword: '當前密碼',
      inputCurr: '請輸入當前密碼',
      newPassword: '新密碼',
      inputNewSet: '請輸需要設置的新密碼',
      confirm: '確認密碼',
      inputAgain: '請再次輸入新的密碼',
      edit: '編輯',
      identify: '賬號身份',
      superAdmin: '超級管理員',
      admin: '管理員',
      completeness: '完整度 60%',
      companyName: '公司名稱',
      operator: '運營人',
      inputOperatorName: '請輸入運營人名稱',
      tel: '聯繫電話',
      inputTel: '請輸入聯繫電話',
      email: '郵箱',
      inputEmail: '請輸入郵箱',
      address: '聯繫地址',
      inputWorkspace: '請輸入工作區名稱',
      cleanerNumber: '清運人員數量',
      carsNumber: '清運車輛數量',
      finishedEdit: '完成編輯',
    },
    show: {
      tab: '顯示',
    },
    editUser: {
      title: '編輯',
      userGroup: '賬戶身份',
      integrity: '完整度',
      errorCompany: '請輸入正確的公司名(不少於6位)',
      errorEmail: '請輸入正確的郵箱',
      errorNumber: '請輸入正確的數字',
      errorPhone: '請輸入正確的電話號碼',
      staff: '人',
      car: '輛',
    },
    orderNew: {
      title: '訂購新設備',
    },
  },

  //serviceAccount.js
  //服务账户国际化
  serviceAccount: {
    serviceAccount: '服務賬戶',
    accountManagement: '用戶管理',
    add: '添加',
    export: '導出',
    regionManagement: '區域管理',
    superior: '管轄歸屬',
    confirm: '確認',
    cancel: '取消',
    regionalLevel: '區域級別：',
    areaName: '區域名稱：',
    editAccount: '編輯賬戶',
    automaticGeneration: '自動生成',
    userName: '用戶名',
    accountPassword: '賬號密碼',
    regionName: '所屬區域',
    permissionSetting: '權限設置',
    initialPassword: '初始密碼',
    permission:'權限',
    edit:'編輯',
    total:'共 ',
    users:' 個用戶',
    all:'全部',
    readOnly:'只讀',
    confirmExportAll:'確認導出當前列表所有賬戶',
    exportAccount:'導出賬戶',
    sureToDelete:'確定刪除',
    NoteForDelete:'注：刪除區域及所屬賬戶',
    EmptyNameWarning:'區域名稱不能為空',
    province:'省',
    city:'市',
    region:'區',
    street:'街道',
    community:'社區',
    enterTheInformation:'請輸入符合規則的信息',
    addAccount:'新建賬戶',
    tips:'提示',
    deleteSuccess:'刪除成功',
    deleteFailByReason:'有下屬行政區存在，無法刪除',
    CompanyUnnamed:'公司未命名',
    pleaseSelect:'請選擇',

  },
  //TestTop.js
  mapDetail: {
    inputID: '請輸入ID',
    search: '搜索',
    refresh: '刷新',
  },

  //createArea.js
  areaPageDetail: {
    //创建大区表单
    districtCreate: {
      account: {
        duplicateAcc: '賬號重複',
        differentTwice: '兩次輸入的密碼不同!',
        districtAcc: '大區賬號',
        accRules: '英文字母開頭,6~18位(字母、數字、下劃線)',
        inputAcc: '請輸入賬號!',
        placeholder: '請輸入賬號',
      },
      password: {
        pass: '密碼',
        passRules: '6~18位(字母、數字、常用字符、字母區分大小寫)',
        inputPass: '請輸入密碼',
        confirm: '確認密碼',
        inputPass2: '請輸入密碼!',
        inputTwice: '請再次輸入密碼',
      },
      districtName: {
        name: '大區名稱',
        inputName: '請輸入大區名稱',
        inputName2: '請輸入大區名稱！',
        rules: '(支持中文、英文、數字、下劃線)',
      },
      admin: {
        name: '管理員姓名',
        inputName: '請輸入管理員名稱',
        inputName2: '請輸入管理員名稱！',
        rules: '(支持中文、英文、數字、下劃線)',
      },
      staff: {
        number: '員工數量（單位:人）',
        wrongFormat: '格式不正確!',
        unit: '(人)',
        inputNumber: '請輸入員工數量',
      },
      vehicle: {
        number: '車輛數量（單位:車）',
        wrongFormat: '格式不正確！',
        unit: '(車)',
        inputNumber: '請輸入車輛數量',
      },
      isCreate: '創建',
      isCancel: '取消',
      establish: '創建',
      establishDistrict: '創建大區',
      completeness: '完整度',
    },
    //创建下属工作区表单
    subWorkAreaCreate: {
      duplicate: '賬號重複',
      Inconsistent: '兩次輸入的密碼不同！',
      workplace: {
        account: '工作區賬號',
        rules: '英文字母開頭，6~18位(字母、數字、下劃線)',
        inputAccount: '請輸入賬號',
        inputAccount2: '請輸入賬號！',
      },
      password: {
        pass: '密碼',
        rules: '6~18位(字母、數字、常用字符、字母區分大小寫)',
        inputPass: '請輸入密碼',
        confirmPass: '確認密碼',
        inputAgain: '請再次輸入密碼',
      },
      workspace: {
        name: '工作區名稱',
        inputName: '請輸入工作區名稱',
        inputName2: '請輸入工作區名稱！',
        rules: '(支持中文、英文、數字、下劃線)',
      },
      cleanerName: {
        name: '清運者名稱',
        inputName: '請輸入清運者員名稱',
        inputName2: '請輸入清運者員名稱！',
        rules: '(支持中文、英文、數字、下劃線)',
      },
      filledWeight: {
        vehicleWeight: '滿車重量（單位:千克）',
        wrongFormat: '格式不正確',
        inputWeight: '請輸入滿車重量',
      },
      isCreate: '創建',
      isCancel: '取消',
      establish: '創建',
      establishSub: '創建下屬工作區賬戶',
      completeness: '完整度',
    },

    //编辑大区表单
    editDistrict: {
      districtInfo: {
        name: '大區名稱',
        rule1: '大區名稱不能為空!',
        rule2: '(支持中文、英文、數字、下劃線)',
        inputName: '請輸入大區名稱',
      },
      admin: {
        manager: '管理員',
        rule1: '管理員名稱不能為空!',
        rule2: '(支持中文、英文、數字、下劃線)',
        inputName: '請輸入管理員名稱',
      },
      contact: {
        contactInfo: '聯繫方式',
        rule: '請輸入正確的電話號碼!',
        inputTel: '請輸入聯繫電話',
      },
      staff: {
        number: '員工數量（單位:人）',
        error: '格式不正確!',
        inputNumber: '請輸入員工數量',
        unit: '(人)',
      },
      vehicle: {
        number: '車輛數量（單位:輛）',
        error: '格式不正確!',
        unit: '(車)',
        inputNumber: '請輸入車輛數量',
      },
      finished: '完成編輯',
      cancel: '取消',
      edit: '編輯',
      districtName: '大區賬號',
      completeness: '完整度',
    },

    //编辑工作区表单
    editWorkspace: {
      districtInfo: {
        name: '工作區名稱',
        error: '工作名稱不能為空!',
        rule: '(支持中文、英文、數字、下劃線)',
        inputWorkspace: '請輸入工作區名稱',
      },
      cleanerInfo: {
        cleaner: '清運者',
        error: '清運者名稱不能為空!',
        rule: '(支持中文、英文、數字、下劃線)',
        inputName: '請輸入清運者名稱',
      },
      contactInfo: {
        contactMethods: '聯繫方式',
        error: '請輸入正確的電話號碼!',
        inputTel: '請輸入聯繫電話',
      },
      vehicle: {
        fullWeight: '滿車重量（单位:千克）',
        error: '格式不正確!',
        inputFullWeight: '請輸入滿車重量',
      },
      finished: '完成編輯',
      cancel: '取消',
      modify: '編輯',
      workAreaAccount: '工作區賬號',
      belong: '所屬大區',
      completeness: '完整度',
    },
  },

  //MyAMap.js
  map: {
    refresh: '刷新',
  },

  //thermodynamic.js
  timeLine: {
    hour: '時',
  },

  //help.jsx
  //帮助模块
  helpCenter: {
    title: '常見問題',
    category: '目錄',
    favor: '您需要哪方面的幫助？',
    search: '在這輸入想找的對象...',
    helpDetail: {
      area: '區域管理',
      getAreaHelp: '獲取區域劃分、人員管理方面的幫助。',
      equipment: '設備管理',
      getEquipment: '獲取故障設備、充值方面的幫助。',
      data: '數據統計',
      getData: '獲取環衛員工數據、勞動量圖、減量數據方面的幫助。',
      account: '賬號管理',
      getAccount: '獲取我的賬戶、歷史訂單、消息中心方面的幫助。',
      noKey: '沒有搜索到您的關鍵字！',
    },
    suggest: {
      relative: '您可能覺得有用的相關問題',
      difference: '“大區”、“工作區”分別是什麼？',
      workArea:
        '工作區是一個清運人員（司機）所負責的區域，並配備一個清運人員（司機）賬號用於工作，而大區是幾個工作區的整合，並配備一個管理員賬號進行管理。',
      distribute: '如何分配箱子到各個區域？',
      install:
        '設備安裝時，用哪個司機賬號進行安裝便會自動將該箱子分配到該司機名下，若後續還要進行調整，請在PC端人員管理界面，對需要調整的工作區進行“分配”操作。',
    },
    support: {
      download: '下載地址：',
      manual: {
        compose: 'Meet hive產品介紹手冊由七部分構成：',
        problem: '第一節 行業難題',
        introduce: '第二節 蜂巢簡介',
        product: '第三節 產品介紹',
        case: '第四節 產品案例',
        install: '第五節 安裝與培訓',
        guarantee: '第六節 質量保證與保修',
        about: '第七節 關於蜂巢',
      },
    },
    contact: {
      humanService:
        '您如果需要人工服務，請致電我們的聯繫電話或者郵件至我們的官方郵箱，郵件請註明公司名。',
      tele: '聯繫電話：+86-15399420457/029-87977358',
      email: '郵箱：hive@hive-intel.com',
      address: '地址：東莞松山湖高新技術產業開發區國際機器人產業基地3樓304室',
      add2: '陝西省西安市蓮湖區二環南路西段395號亞美偉博廣場907室',
    },
    official: {
      officialPc: 'HI環衛電腦端網址',
      pcwebsite: 'http://pc.hive-intel.com',
      applet: 'HI環衛微信小程序',
      des: 'HI環衛',
      titleDes: 'HI環衛',
      appletDes: 'APP',
      installApplet: '設備安裝APP',
      position: 'HI箱體定位工具',
      positionTool: 'HI箱體定位工具',
      serviceAccount: '微信服務號',
      hiClear: 'HI清運',
      serviceAcc: '服務號',
      officialAcc: '微信訂閱號',
      brand: 'Meet Hive蜂巢智慧',
      brand2: 'Meet Hive蜂巢智慧',
      subscribe: '訂閱號',
      officialWebsite: '蜂巢官網',
      webAddress: 'http://hive-intel.com',
    },
    countenance: '支持',
    content: '目錄',
    whatYouNeed: '您需要哪方面的幫助？',
    inputToSearch: '在這輸入想找的對象...',
    about: {
      downloadDocs: '文檔下載',
      getFile: '獲取安裝指南、試用指南等文檔的下載和瀏覽。',
      contact: 'HI環衛相關聯繫方式。',
      getTouch: '獲取HI環衛服務熱線、郵箱等方面的幫助。',
      official: 'HI環衛官方平台',
      getOfficial: '獲取HI箱體定位工具、服務號信息等方面的幫助。',
      contactUs: '聯繫我們',
      phone: '029-87977358',
      noKey: '沒有搜索到您的關鍵字！',
    },
  },
  //区域动态
  sanitation: {
    title: '區域動態',
    des1: '目前有',
    des2: '個工作區',
    cleanerBtn: '管理路徑',
    cleanerDetail: '詳情',
  },
  //路径规划
  pathPlanning: {
    map: {
      start: '起點',
      end: '終點',
      setGarage: '選為車庫',
      setWarehouse: '選為倉庫',
      expectedRecyclable: '預計可回收',
      haveReceived: '已收',
      actually: '實際',
      history: '歷史',
      Intelligence: '智能',
    },
    sure: '確定',
    cancel: '取消',
    dialogTitle: '設置智能規劃參數',
    noPoint: '未設置車庫倉庫位置,在上方設置後方可看到詳細路徑。',
    pointBtn: '應用',
    createNewPath: '創建新路徑',
    addressCanNotEmpty: '車庫倉庫需要一起設置，請填寫完整！',
    garageTips: '請選擇具體的地址！',
    startPoint: '起點',
    endPoint: '終點',
    garageLabel: '車庫',
    carSpace: '回收車空間',
    carSpaceTips: '規劃時回收車可能不是空載狀態，因此需要設置此參數',
    minVolume: '回收箱最低貨量',
    minVolumeTips: '低於此貨量的回收箱不納入智能規劃中',
    garagePlaceholder: '請輸入車庫名稱',
    warehouseTips: '請選擇具體地址',
    warehouseLabel: '倉庫',
    warehousePlaceholder: '請輸入倉庫名稱',
    setPointSuccess: '設置成功!',
    setPointFail: '設置失敗，請稍後再試!',
    clearRoute: '實際清運路線',
    clearDesKg: '千克',
    clearDesKil: '公里',
    clearDesHour: '小時',
    clearDesOne: '清運了',
    clearDesTwo: '行駛',
    clearThree: '耗時',
    clearDesFour: '路線效率',
    historyRouteShow: '顯示到地圖',
    historyRouteUnShow: '隱藏',
    historyRouteTitle: '歷史智能規劃路線',
    historyDesOne: '可清運',
    historyDesTwo: '將行駛',
    historyDesThree: '參數',
    historyFour: '以下不收',
    historyBuild: '創建於',
    historyCarSpace: '車子空間',
    historyMinVolume: '回收箱',
    planningTitle: '當前智能規劃路線',
    noPlanningTips: '暫無智能規劃路線',
    noPlanningTipsDes: '您可以在這為員工設置您想要的智能規劃路線。',
    noPlanningBtn: '創建',
    pageTipsTitle: '提示',
    pageTipsContent:
      '請檢查滿車重量是否設置，若正確設置仍無法規劃，請聯繫客服。',
  },
  //规格管理页面
  specification: {
    unassigned: '未分配',
    pageTitle: '規格管理',
    searchContent: '在這輸入你想找的對象...',
    selectAll: '全選',
    equipmentName: '設備名稱',
    equipmentId: '設備編號',
    areaChoseAll: '全部',
    specChoseAll: '全部規格',
    operating: '操作',
    modifySpec: '更換規格',
    replace: '更換規格包',
    specPackage: '規格包',
    sonCanName: '箱體數量',
    labelSpec: '標籤/規格',
    addPackage: '添加規格包',
    packageName: '規格包名稱',
    household: '廚餘垃圾',
    hazardous: '有害垃圾',
    residual: '其它垃圾',
    recyclable: '可回收垃圾',
    customize: '自定義',
    total: '共',
    records: '個設備',
    previous: '上一頁',
    next: '下一頁',
    pages: '頁',
    batchEdit: '批量修改',
    modifySpecInBatch: '批量修改規格',
    selected: '已選',
    devices: '個箱體',
    specificationList: '規格列表',
    installHeight: '安裝高度',
    fullDevicesHeight: '滿箱高度',
    fullDevicesWeight: '滿箱重量',
    meter: '米',
    kilogram: '千克',
    edit: '編輯',
    delete: '刪除',
    add: '添加規格',
    addNewSpecification: '添加新規格',
    addTipsOne: '該值不應大於450釐米',
    addTipsTwo: '滿箱高度不應該大於安裝高度',
    addTipsThree: '箱體規格名稱重複，請重新填寫提交。',
    addTipsFour: '箱體規格參數重複，請重新填寫提交。',
    completion: '完整度',
    specificationName: '規格名稱',
    inputTips: '點擊設置',
    inputErrTips: '請填寫完整',
    inputErrTipsTwo: '請填寫數字',
    devicesType: '箱體類型',
    selectType: '請選擇箱體類型!',
    clothingBox: '衣物箱',
    trashBox: '垃圾箱',
    transferBox: '中轉箱',
    finishEdit: '完成編輯',
    finish: '完成添加',
    cancel: '取消',
    selectSpec: '選擇規格',
    selectTips:
      '在此刻選擇的是已創建的規格，如果有其他的規格需求，可以按照需求在此頁面創建新的規格。',
    selectDes: '您可以自由選擇已有的規格列表中的規格',
    installTips:
      '“安裝高度“指的是設備安裝的位置到箱子底部的距離，正確填寫才可以保證設備的測量精度。',
    fullHeightTips:
      '“滿箱高度“指的是貴公司所認為的箱體爆滿報警線的位置，正確填寫才可以保證設備的測量精度。',
    fullWeightTips:
      '“滿箱重量“指的是貴公司箱體爆滿時可收集出的貨物的重量，正確填寫才可以保證年、月、日等報表上的數據準確。',
    tips: '提示',
    yes: '是',
    no: '否',
    confirm: '確定',
    deleteContent: '請確定是否執行“刪除”操作',
    deleteErrTips: '當前規格無法刪除',
    editTips:
      '有箱體正在使用該規格，是否將變化應用到這些箱體。點擊否將新添加規格。',
    error: {
      authority: '您無權限執行此操作。',
      nameRepeat: '箱體規格名稱重複，請重新填寫提交。',
      parameterRepeat: '箱體規格參數重複，請重新填寫提交。',
      dragNum: '請選擇和該設備相匹配的規格包',
      isUsing: '此規格包有箱體正在使用，禁止修改，請新建規格包',
    },
    replaceSpecPackage: '更換規格包',
    selectSpecPackage: '選擇規格包',
    confirmToReplace: '確定更換',
    spePackageSameName: '規格包名稱重複',
    specPackSameParams: '存在相同參數的規格包',
  },
  power: {
    pageTitle: '電量管理',
    searchContent: '請輸入名稱或編號查找',
    tableTitle: {
      selectAll: '全選',
      deviceName: '設備名稱',
      deviceID: '設備編號',
      areaAll: '全部',
      power: '剩餘電量',
      life: '預期壽命',
      month: '月',
      sensitive: '上報閾值',
      action: '操作',
      button: '修改閾值',
      total: '共',
      device: '個設備',
      multiChange: '批量修改',
      powerError: '電量異常',
      unassigned: '未分配',
      unnamed: '未命名',
    },
    tips: {
      title: '提示',
      lineOne: '修改閾值用於設備功耗與實時性的動態平衡。',
      lineTwo: '降低閾值將提高設備數據上報的實時性，但也會增加設備的功耗。',
      lineThree: '提高閾值將減少設備的功耗同時降低設備數據上報的實時性。',
      lineFour: '閾值建議取值範圍：5%~25%。',
    },
    change: {
      title: '修改閾值',
      original: '原阈值',
      new: '新阈值',
      cancel: '取消',
      confirm: '完成修改',
      select: '已選中',
      device: '個設備',
    },
  },
  recharge: {
    pageTitle: '設備充值',
    searchContent: '在這裡輸入想找的對象',
    automaticRenewal: '自動續費',
    turnOn: '開啟',
    shutDown: '關閉',
    atWork: '工作中',
    expired: '已到期',
    dueSoon: '即將到期',
    toSettle: '去續費',
    noPermission: '權限不足，請聯繫超級管理員進行操作',
  },
  orderHistory: {
    confirm: '確定',
    reset: '重置',
    emptyText: '暫無數據',
    title: '歷史訂單',
    event: '事件',
    number: '數量',
    transactionHour: '交易時間',
    amount: '金額',
    orderNum: '訂單編號',
    equipmentOrder: '設備訂購',
    equipmentRenewal: '設備續費',
    accountRecharge: '賬戶充值',
    other: '其他',
    orderState: {
      done: '已完成',
      close: '已關閉',
      toBePaid: '待支付',
    },
    alipay: '支付寶',
    weChatPay: '微信支付',
    accountBalance: '賬戶餘額',
    toPay: '去支付',
  },
  orderDetail: {
    year: '年',
    month: '個月',
    title: '歷史訂單',
    orderDetail: '訂單詳情',
    detail: '詳情',
    orderNum: '訂單號',
    expirationTime: '支付過期時間',
    operating: '操作',
    pay: '支付',
    cancel: '取消',
    state: '狀態',
    unpaid: '未支付',
    orderTime: '下單時間',
    originalPrice: '原價',
    yuan: '元',
    amountToPaid: '待支付金額',
    orderPrice: '訂單金額',
    payPrice: '支付金額',
    rechargeToAccount: '充值已到賬，去',
    account: '賬戶',
    view: '查看',
    order: '訂單明細',
    product: '產品/實例id',
    paymentMethod: '支付方式',
    duration: '時長',
    expireDate: '購買後到期時間',
    price: '價格',
    model: '型號',
    scenes: '場景',
    poweredBy: '供電',
    communicationMode: '通信模式',
    rangingDistance: '測距距離',
    integrationType: '集成類型',
    none: '無',
    integrationTxt: '探頭集成款',
    typeOfInstallation: '安裝類型',
    position: '定位',
    discount: '已優惠',
    saving: '已省',
  },
  payProcess: {
    pay: '支付',
    minute: '分',
    second: '秒',
    payOrder: '訂單支付',
    accountNumber: '賬號',
    transactionNumber: '交易號',
    commodityOrder: '商品訂單',
    originalOrder: '原始訂單',
    paymentAmount: '支付金額',
    orderDetails: '訂單詳情',
    orderTime: '下單時間',
    payTheRemainingTime: '支付剩餘時間',
    payResult: '支付結果',
    paymentSuccessful: '支付成功',
    paymentFailed: '支付失敗',
    close: '關閉',
    weChatPay: '打開手機微信，掃一掃完成支付',
    alipay: '打開手機支付寶，掃一掃完成支付',
  },
  payment: {
    confirm: {
      detail: '產品詳情',
      count: '總數量',
      duration: '使用時長',
      durationHelp: '設備激活後開始計算使用時長',
      price: '價格',
      autoCharge: '自動續費',
      info: '配置基本信息',
      agree: '我已閱讀並同意',
      licese: '《蜂巢智慧衣物回收產品服務協議》',
      totalFee: '總計費用',
      confirm: '確認下單',
      confirmPay: '確認支付',
      year: '年',
      errorTips: '請勾選產品服務協議後購買！',
      name: '名稱',
      partition: '分區',
      principal: '負責人',
    },
    balance: {
      chargeAccount: '充值帳戶',
      remain: '賬戶餘額',
      charge: '充值',
      chargePrice: '充值金額',
      chargeTips: '充值說明',
      chargeTipsFir: '充值不可退款，請謹慎操作',
      chargeTipsSec: '充值金額消費後才可開具發票',
    },
    charge: {
      availTime: '到期時間',
      chargeTime: '續費時長',
      newAvailTime: '續費後到期時間',
      discountTip: '購買半年時長，包月預付優惠價基礎，再享8.3折優惠',
      action: '詳情',
      viewDevice: '查看設備',
    },
    begin: {
      target: '交易對象',
      company: '蜂巢智慧智能科技有限公司',
      order: '訂單號',
      withBalance: '當前餘額',
      availbleBalance: '可用餘額',
      yuan: '元',
      thirdPay: '使用其他方式支付',
      thirdPayHelp:
        '在線支付僅支持以下三種支付渠道，點擊“立即支付”後您可在新開頁面選擇其中任意一種渠道進行支付',
      thirdLimit: '交易限額說明',
      thirdLimitHelpFir: '1.蜂巢智慧平台的交易限額：0.01-9999999元;',
      thirdLimitHelpSec:
        '2.微信支付/支付寶支付/網銀會依據銀行要求進行交易額度的限制，以保證您的資金安全。不同支付平台、不同銀行、不同卡類型對應限額額度不同，具體額度請以您實際支付中的提示為準；',
      thirdLimitHelpThi: '3.大額交易建議您可使用線下匯款充值。',
      totalFee: '訂單金額',
      confirm: '立即支付',
      orderTips: '溫馨提示：請在15分鐘內完成訂單支付，15分鐘後訂單將自動關閉',
      okText: '支付成功',
      cancelText: '支付失敗，重試',
      wait: '等待支付',
      autoCancel: '秒後訂單將自動關閉',
      newPage: '請在新頁面中完成支付',
      reopen: '重新打開',
      loading: '正在更新訂單狀態',
    },
    result: {
      success: '支付成功',
      fail: '支付失敗',
      successTo: '秒後進入訂單詳情頁',
      failTo: '查看訂單',
    },
    step: {
      confirm: '確認訂單',
      begin: '支付',
      result: '支付結果',
      info: '支付',
    },
  },
}



// WEBPACK FOOTER //
// ./src/i18n/zh-tw.js